import React, { useEffect, useState } from "react";
import "./verification.scss";
import {
  Box,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import brandStore from "../../store/brandStore";
import authStore from "../../store/authStore";
import { LoadingButton } from "@mui/lab";
import { useNavigate, Navigate, Link } from "react-router-dom";
import snackbarStore from "../../store/snackbarStore";
import { BRAND_NAME_LOGO, ENV } from "../../constant";
import SEO from "components/seo/SEO";

const ChangePasswordAndPhoneNoVerification = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const navigate = useNavigate();
  const BrandStore = brandStore();
  const AuthStore = authStore();
  const SnackbarStore = snackbarStore();

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [inputOTP, setInputOTP] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (AuthStore.OTP === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (SnackbarStore.massage !== "") {
      SnackbarStore.setIsOpen({ value: true });
    }
  }, [SnackbarStore.massage]);

  const verifyOTP = async () => {
    setIsLoading(true);
    let isVerify = false;
    if (ENV === "production") {
      isVerify = await AuthStore.otpVerification({
        email: AuthStore.isOTPScreenEmail,
        otp: inputOTP,
      });
    } else {
      isVerify = AuthStore.OTP === parseInt(inputOTP);
    }

    if (isVerify) {
      setIsError(false);
      setIsLoading(false);
      if (AuthStore.whereNavigate === "change-phone-no") {
        navigate(`/${AuthStore.whereNavigate}`, { replace: true });
      } else {
        navigate(`/reset-password`, { replace: true });
      }
    } else {
      setIsLoading(false);
      setIsError(true);
    }
  };

  return (
    <Grid
      container
      component="main"
      className="sing-up"
      sx={{ p: isNonMobile ? "50px" : "10px" }}
    >
      <SEO
        title="Kristive Perfumes | Luxury Fragrances for Men & Women"
        description="Experience luxury with Kristive's exquisite perfume collection. Fragrances for men and women, blending rare ingredients with timeless artistry. Discover your signature scent today."
        noFollow
        noIndex
        noImageIndex
      />
      <Container component="main" maxWidth="xs">
        <Box component="div" className="container">
          <Box component="div" className="brand-name-logo-container">
            <Link to={"/"} component="div" className="brand-name-logo">
              <img src={BRAND_NAME_LOGO} alt="brand-logo" />
            </Link>
          </Box>

          <Typography component="h1" variant="h5" className="title">
            Verify OTP
          </Typography>
          <Stack spacing={2} sx={{ mt: 3 }}>
            <p style={{ textAlign: "center" }}>
              Enter the code we just send on your email{" "}
              {AuthStore.isOTPScreenEmail.substring(0, 4)}
              ****@gmail.com OTP
            </p>
            <TextField
              name="OTP"
              inputProps={{
                inputMode: "numeric",
                maxLength: 6,
                style: { textAlign: "center" },
              }}
              required
              error={isError}
              helperText={isError && "Enter valid OTP"}
              fullWidth
              label="OTP"
              value={inputOTP}
              onChange={(e) => setInputOTP(e.target.value)}
            />
            <div className="btn">
              <LoadingButton
                loading={isLoading}
                variant="contained"
                fullWidth
                disabled={inputOTP.length === 6 ? false : true}
                style={{
                  background:
                    !isLoading && inputOTP.length === 6
                      ? "#000"
                      : "hsl(220, 10%, 94%)",
                }}
                onClick={verifyOTP}
              >
                <p>Verify</p>
              </LoadingButton>
            </div>
          </Stack>
        </Box>
      </Container>
    </Grid>
  );
};

export default ChangePasswordAndPhoneNoVerification;
